import React from 'react';

const STATUS_CONFIG = {
  completed: { class: 'completed', icon: 'bi-check-circle', text: 'Completed' },
  processing: { class: 'processing', icon: 'bi-clock', text: 'Processing' },
  failed: { class: 'failed', icon: 'bi-x-circle', text: 'Failed' },
  pending: { class: 'pending', icon: 'bi-hourglass', text: 'Pending' }
} as const;

interface StatusBadgeProps {
  status: string;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  const config = STATUS_CONFIG[status as keyof typeof STATUS_CONFIG] || STATUS_CONFIG.pending;
  return (
    <span className={`status-badge ${config.class}`}>
      <i className={`bi ${config.icon} me-1`}></i>
      {config.text}
    </span>
  );
};

export default StatusBadge;
